import * as App from "./portfolio/index";

App.start();
